import _ from "lodash";

import { Contracts } from "./Contracts";

export class ContractPermission {
    Contracts = Contracts;

    constructor() {}

    hideModuleBySource({ contract, module, source }) {
        if (!contract || !module || !source) throw new Error("Invalid params.");

        const modulePermission = this.getModulePermissionBySource({
            contract,
            module,
            source
        });

        return {
            sourceContracted: modulePermission.sourceContracted,
            hide: modulePermission.hide
        };
    }

    isContractedModuleBySource({ contract, module, source }) {
        if (!contract || !module || !source) throw new Error("Invalid params.");

        const modulePermission = this.getModulePermissionBySource({
            contract,
            module,
            source
        });

        return modulePermission.sourceContracted;
    }

    isContractedModule({ contract, module }) {
        if (!contract || !module) throw new Error("Invalid params.");

        const modulePermission = this.getModulePermission({ contract, module });

        return modulePermission.contracted;
    }

    getModulePermissionBySource({ contract, module, source }) {
        if (!contract || !module || !source) throw new Error("Invalid params.");

        const modulePermission = this.getModulePermission({ contract, module });

        if (!modulePermission.contracted)
            return { ...modulePermission, sourceContracted: false };

        if (!modulePermission.sources)
            return {
                ...modulePermission,
                sourceContracted: modulePermission.contracted
            };

        if (modulePermission.sources.includes(source))
            return { ...modulePermission, sourceContracted: true };

        return { ...modulePermission, sourceContracted: false };
    }

    getModulePermission({ contract, module }) {
        if (!contract || !module) throw new Error("Invalid params.");

        const modulePermission = _.get(
            Contracts,
            `${contract}.Modules.${module}`
        );

        if (!modulePermission) return { contracted: false };

        return modulePermission;
    }

    getFeaturePermission({ contract, feature }) {
        if (!contract || !feature) throw new Error("Invalid params.");

        const featurePermission = _.get(
            Contracts,
            `${contract}.Features.${feature}`
        );

        if (!featurePermission) return { contracted: false };

        return featurePermission;
    }

    isContractedFeature({ contract, feature }) {
        if (!contract || !feature) throw new Error("Invalid params.");

        const featurePermission = this.getFeaturePermission({
            contract,
            feature
        });

        return featurePermission.contracted;
    }

    getContractedsOfFeature({ feature }) {
        if (!feature) throw new Error("Invalid params.");

        const contracts = [];

        const contractsKeys = Object.keys(Contracts);

        for (const contractKey of contractsKeys) {
            const isContractedFeature = this.isContractedFeature({
                contract: contractKey,
                feature: "Themes"
            });

            if (isContractedFeature) contracts.push(contractKey);
        }

        return contracts;
    }

    getSourcesContractedsByModule({ contract, module }) {
        return {
            accounting: this.isContractedModuleBySource({
                contract,
                module,
                source: "accounting"
            }),
            fin: this.isContractedModuleBySource({
                contract,
                module,
                source: "fin"
            }),
            tax: this.isContractedModuleBySource({
                contract,
                module,
                source: "tax"
            }),
            personnel: this.isContractedModuleBySource({
                contract,
                module,
                source: "personnel"
            }),
            eSocial: this.isContractedModuleBySource({
                contract,
                module,
                source: "eSocial"
            }),
            simplesNacional: this.isContractedModuleBySource({
                contract,
                module,
                source: "simplesNacional"
            })
        };
    }

    verifyContractedSource({ contract, module, source }) {
        if (!contract || !module || !source) throw new Error("Invalid params.");

        const modulePermission = this.getModulePermissionBySource({
            contract,
            module,
            source
        });

        if (!modulePermission.sourceContracted) {
            return _.get(modulePermission, `sources[0]`);
        }

        return source;
    }
}
